import StockSlide from './StockSlide';

export default StockSlide;
